'use strict';

class Overview {
    constructor($window, $scope, $sce, $location, overviewService, offerService, orderConfirmationService, Notification, originatorService) {
        this.$window = $window;
        this.$scope = $scope;
        this.$sce = $sce;
        this.$location = $location;
        this.overviewService = overviewService;
        this.offerService = offerService;
        this.orderConfirmationService = orderConfirmationService;
        this.Notification = Notification;
        this.originatorService = originatorService;
    }

    $onInit() {
        this.overview = {
            years: []
        };

        this.year = this.$window.sessionStorage.getItem('selectedOverviewYear');
        //not to load twice on startup
        this.offers = [];
        this.orderConfirmations = [];

        this.originatorService.get()
            .then((resp) => {
                this.originator = resp.data;
            });

        this.load();
        this.loadOffers();
        this.loadOrderConfirmations();
        //   this.$scope.$watch('$ctrl.year', (val) => {
        //     console.log(val);
        //     console.log(this.year);
        //     if (val) {
        //       this.$window.sessionStorage.setItem('selectedOverviewYear', val);
        //       this.load();
        //     }
        //   });
        // }
        //
    }

    yearChanged() {
        this.$window.sessionStorage.setItem('selectedOverviewYear', this.year);
        this.load();
    }

    load() {
        let year = this.$window.sessionStorage.getItem('selectedOverviewYear');
        this.overviewService.get(year)
            .then((resp) => {
                if (resp.data && resp.status !== 204 && resp.data.groups) {
                    resp.data.groups.map((group) => {
                        group.name = this.$sce.trustAsHtml(group.name);
                        return group;
                    }, this);

                    return resp.data;
                } else {
                    return [];
                }
            })
            .then((list) => {
                this.overview = list;

                // assign last active year first
                if (this.year === null) {
                    this.year = '' + this.overview.years[list.years.length - 1];
                    this.$window.sessionStorage.setItem('selectedOverviewYear', this.year);
                }

                // if the list is empty go to the start page
                if (list.years && !list.years.length) {
                    this.$location.path('/');
                }
            });
    }

    loadOffers() {
        this.offerService.getOpen()
            .then((resp) => {
                this.offers = resp.data;
            });
    }

    /**
     * Start an invoice based on the offer
     *
     * @param {Object} document Original document
     */
    copyFromOffer(document = {}) {
        if (document.draftInvoiceNumber !== null) {
            if (this.originator.giroLayout) {
                this.$location.path(`/regning/kladd/${document.draftInvoiceNumber}`).search('tilbud', document.number);
            } else {
                this.$location.path(`/regning/kladd/utengiro/${document.draftInvoiceNumber}`).search('tilbud', document.number);
            }
        } else {
            if (this.originator.giroLayout) {
                this.$location.path('/regning/kladd/ny').search('tilbud', document.number);
            } else {
                this.$location.path('/regning/kladd/utengiro/ny').search('tilbud', document.number);
            }
        }
    }

    loadOrderConfirmations() {
        this.orderConfirmationService.getSent()
            .then((resp) => {
                this.orderConfirmations = resp.data;
            });
    }

    /**
     * Start an invoice based on the order confirmation
     *
     * @param {Object} document Original document
     */
    copyFromOrderConfirmation(document) {
        if (document.draftInvoiceNumber !== null) {
            if (this.originator.giroLayout) {
                this.$location.path(`/regning/kladd/${document.draftInvoiceNumber}`).search('ordrebekreftelse', document.number);
            } else {
                this.$location.path(`/regning/kladd/utengiro/${document.draftInvoiceNumber}`).search('ordrebekreftelse', document.number);
            }
        } else {
            if (this.originator.giroLayout) {
                this.$location.path('/regning/kladd/ny').search('ordrebekreftelse', document.number);
            } else {
                this.$location.path('/regning/kladd/utengiro/ny').search('ordrebekreftelse', document.number);
            }
        }
    }

    parseUri(uri) {
        return {
            state: uri.match(/state=(\w+)/)[1],
            type: uri.match(/type=(\w+)/)[1],
            year: uri.match(/year=(\w+)/)[1] || 'all'
        };
    }

    // parse the _links section and send forward
    select(uri) {
        if (uri) {
            let params = this.parseUri(uri);

            if (params.state !== null && params.type !== null && params.year !== null) {
                if (params.year === 'null') {
                    params.year = this.year;
                }

                this.$location
                    .search('state', params.state)
                    .search('type', params.type)
                    .path('/oversikt/' + params.year);
            }
        }
    }
}

Overview.$inject = ['$window', '$scope', '$sce', '$location', 'overviewService', 'offerService', 'orderConfirmationService', 'Notification', 'originatorService'];

const overview = {
    controller: Overview,
    template: `
    <div class="row">
      <div class="large-3 columns">
        <h2>Oversikt</h2>
      </div>
      <div class="large-9 columns right-align">
        <a ng-show="$ctrl.originator && $ctrl.originator.giroLayout" href="#/regning/kladd/ny" class="button" role="button"><i class="fa fa-file"></i> Ny regning</a>
        <a ng-show="$ctrl.originator && !$ctrl.originator.giroLayout" href="#/regning/kladd/utengiro/ny" class="button" role="button"><i class="fa fa-file"></i> Ny regning</a>
        <a href class="button secondary" role="button" ng-click="offerTable = true" ng-show="$ctrl.offers.length"><i class="fa fa-copy"></i> Fra tilbud</a>
        <a href class="button secondary" role="button" ng-click="orderConfirmationTable = true" ng-show="$ctrl.orderConfirmations.length"><i class="fa fa-paste"></i> Fra ordrebekreftelse</a>
      </div>
    </div>

    <div class="row">
      <div class="large-2 columns">
        <select class="select-box" ng-model="$ctrl.year" ng-change="$ctrl.yearChanged()">
          <option value="all">Alle &aring;r</option>
          <option ng-repeat="y in $ctrl.overview.years | orderBy:y:true">{{ y }}</option>
        </select>
      </div>
      <div class="large-10 columns"></div>
    </div>

    <div class="row">
      <div class="large-6 columns">
        <a ng-href="#/oversikt/{{$ctrl.year}}">Alle regninger i valgt år</a>
        <div ng-repeat="group in $ctrl.overview.groups track by $index">
          <overview-widget ng-if="group.name == 'Sendte regninger - ikke betalt'" data="group"></overview-widget>
          <overview-widget ng-if="group.name == 'Pengene har kommet inn<br><em>(husk ev. trekke fra kredit/tapte regninger)</em>'" data="group"></overview-widget>
          <overview-widget ng-if="group.name == 'Kredit/tapte regninger'" data="group"></overview-widget>
        </div>
      </div>
      <div class="large-6 columns">
        <div ng-repeat="group in $ctrl.overview.groups | orderBy:name:true track by $index">
          <overview-widget ng-if="group.name == 'Grunnlag for nye regninger'" data="group"></overview-widget>
          <overview-widget ng-if="group.name == 'Regninger du arbeider med'" data="group"></overview-widget>
        </div>
      </div>
    </div>

    <!-- Open offers -->
    <div modal visible="offerTable">
      <h3 class="subheader">Velg grunnlag for tilbud</h3>

      <table ng-if="$ctrl.offers.length">
        <thead>
          <tr>
            <th class="hide-for-small">#</th>
            <th>Kunde</th>
            <th>Dato</th>
            <th class="hide-for-small">Gyldig til</th>
            <th class="right-align">Bel&oslash;p</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="document in $ctrl.offers | orderBy:'number':true track by $index" ng-click="$ctrl.copyFromOffer(document)">
            <td class="hide-for-small" ng-bind="document.number"></td>
            <td ng-bind="document.recipientName"></td>
            <td ng-bind="document.offerDate | dateFormat"></td>
            <td class="hide-for-small" ng-bind="document.expiryDate | dateFormat"></td>
            <td class="right-align nowrap">{{ document.total | crowns }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Open order confirmations -->
    <div modal visible="orderConfirmationTable">
      <h3 class="subheader">Velg grunnlag for ordrebekreftelse</h3>

      <table ng-if="$ctrl.orderConfirmations.length">
        <thead>
          <tr>
            <th class="hide-for-small">#</th>
            <th>Kunde</th>
            <th class="hide-for-small">Dato</th>
            <th>Bel&oslash;p</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="document in $ctrl.orderConfirmations | orderBy:'number':true track by $index" ng-click="$ctrl.copyFromOrderConfirmation(document)">
            <td class="hide-for-small" ng-bind="document.number"></td>
            <td ng-bind="document.recipientName"></td>
            <td class="hide-for-small" ng-bind="document.orderConfirmationDate | dateFormat"></td>
            <td class="right-align nowrap">{{ document.total | crowns }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  `
};

angular
    .module('SendRegning')
    .component('overview', overview)
    .config(($routeProvider) => {
        $routeProvider
            .when('/oversikt', {
                title: 'Oversikt',
                template: '<overview />',
                secure: true
            });
    });
